import request from '@/libs/request'
import axios from "axios";

//包装记录 列表
export function plantProductionPackingListApi (data) {
  return request({
    url: `plant/plantProductionPacking`,
    method: 'get',
    params: data
  })
}

//包装记录 详情
export function plantProductionPackingInfoApi (id) {
  return request({
    url: `plant/plantProductionPacking/` + id,
    method: 'get'
  })
}


//包装记录 编辑/添加
export function plantProductionPackingSaveApi (data) {
  return request({
    url: `plant/plantProductionPacking`,
    method: 'post',
    data: data
  })
}

//包装记录 删除
export function plantProductionPackingDelApi (id) {
  return request({
    url: `plant/plantProductionPacking/` + id,
    method: 'delete'
  })
}


